<!-- Use this one for modals like LoginModal, SuccessModal -->
<template>
  <modal-base @clickOverlay="$emit('close')">
    <div class="popup">
      <div class="popup__title">
        <slot name="header" />
      </div>
      <icon-base class="popup__close" @click.native="$emit('close')" red>
        <icon-cross/>
      </icon-base>
      <div class="popup__wrap">
        <slot name="body" />
      </div>
    </div>
  </modal-base>
</template>

<script>
import ModalBase from 'Common/ModalBase';
import { IconCross } from 'Icons';

export default {
  components: {
    ModalBase,
    IconCross,
  },
};
</script>


<style lang="scss" scoped>
.popup {
  background: $white-color2;
  position: relative;
  border-radius: 5px;
  margin: 60px 0;
  &__title {
    @include font(24px, $black-color1, 500);
    overflow: hidden;
    border-bottom: 1px solid $white-color5;
    padding: 31px 30px;
    height: 90px;
    display: flex;
    align-items: center;
    .phone-change-popup & {
      flex-direction: column;
      height: auto;
      justify-content: flex-start;
      align-items: flex-start;
    }
  }
  &__close {
    cursor: pointer;
    position: absolute;
    right: 30px;
    top: 30px;
  }
}
  @media screen and (max-width: $max-mobile-width) {
    .popup {
      &__close {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/PopupBase.vue